import React from "react";

export default function Resume() {
  return (
    <>
      <section id="resume" className="resume">
        <div className="container">
          <div className="section-title">
            <h2>Career</h2>
          </div>

          <div className="row">
            <div className="col-lg-6" data-aos="fade-up">
              <h3 className="resume-title">Sumary</h3>
              <div className="resume-item pb-0">
                <h4>Harshal Nirbhavane</h4>
                <p style={{ "textAlign": "justify" }}>
                  <em>
                    As an innovative and deadline-driven digital marketing professional, I bring over 8 years of experience in digital marketing, graphics, web designing, and development. With expertise in developing user-centered digital and print marketing materials, I handle the entire process from initial concept to the final, polished deliverable. Additionally, I excel in creating impactful websites and mobile apps.
                  </em>
                 
                </p>
                <p style={{ "textAlign": "justify" }}> <em>With expertise in digital marketing, web design, web development, customized software solutions, graphics design, and comprehensive training services, I offer a holistic range of services to cater to diverse business needs. My team and I are dedicated to delivering innovative solutions that drive online visibility, engage audiences, and empower businesses to thrive in the digital landscape. Whether it's creating stunning websites, developing tailored software, designing captivating graphics, or providing professional training, we are committed to helping clients achieve their goals and stand out in their respective industries.</em></p>

              </div>

              <h3 className="resume-title">Education</h3>
              <div className="resume-item">
                <h4>Certification in digital marketing &amp; E-commerce</h4>
                <h5>2015 - 2016</h5>
                <p>
                  <em>Indian Institute of Digital Marketing, Mumbai</em>
                </p>
                <p>
                  I have gained advanced expertise in digital marketing, encompassing a wide range of concepts such as building successful digital advertising campaigns, conducting prerequisite and post-analytics, and implementing effective re-targeting strategies.
                </p>
              </div>
              <div className="resume-item">
                <h4>PG Diploma in Advanced Computing</h4>
                <h5>2014</h5>
                <p>
                  <em>MET's BKC IIT</em>
                </p>
                <p>
                  I have acquired comprehensive programming skills, specializing in the development of highly secure and proficient web applications and software. My expertise extends to working with various databases and implementing robust architectural frameworks.
                </p>
              </div>
              <div className="resume-item">
                <h4>Master in Computer Application</h4>
                <h5>2009 - 2012</h5>
                <p>
                  <em>MET's BKC IOE</em>
                </p>
                <p>
                  This academic postgraduate course has significantly enhanced my skills and abilities in the IT field, enabling me to excel in my professional journey.
                </p>
              </div>
              <div className="resume-item">
                <h4>B.sc (Computer Science)</h4>
                <h5>2005 - 2009</h5>
                <p>
                  <em>University of Pune</em>
                </p>
                <p>
                  I have acquired a solid foundation in programming languages, which has greatly empowered me to efficiently engineer software, web, and mobile applications.
                </p>
              </div>
              <div className="resume-item">
                <h4>B. Com (Banking &amp; Finance)</h4>
                <h5>2005 - 2008</h5>
                <p>
                  <em>Y.C. M. O. U.</em>
                </p>
                <p>
                  I pursued this course to acquire knowledge and insights into business accounting processes, enabling me to make informed decisions in the realm of finance.
                </p>
              </div>
            </div>
            <div className="col-lg-6" data-aos="fade-up" data-aos-delay="100">
              <h3 className="resume-title">Professional Experience</h3>
              <div className="resume-item">
                <h4>Sr. Software Developer</h4>
                <h5>2021 - 2022</h5>
                <p>
                  <em>Indian Talent Olympiad </em>
                </p>
                <ul>
                  <li>
                    Designed and developed in-house software and web projects to meet diverse business needs and drive operational efficiency.
                  </li>
                  <li>
                    Analyzed leads through software portals, leveraging data-driven insights to optimize lead generation and conversion strategies.
                  </li>
                  <li>
                    Maintained web portals, ensuring smooth operation, optimal performance, and a seamless user experience.
                  </li>

                </ul>
              </div>
              <div className="resume-item">
                <h4>Digital Marketing Incharge</h4>
                <h5>2018 - 2020</h5>
                <p>
                  <em>Kothari Cars Pvt LTD, Pune, India </em>
                </p>
                <ul>
                  <li>
                    Achieved lead generation through various digital marketing activities, including social media engagement, search engine advertising, video marketing, customized web applications, and bulk SMS campaigns.
                  </li>
                  <li>
                    Conducted thorough analysis of digital marketing activities, optimizing lead targeting strategies and budgets to maximize goal achievement.
                  </li>
                  <li>
                    Developed in-house Android and web applications to enhance digital marketing initiatives and drive better results.
                  </li>
                  <li>
                    Created visually appealing digital marketing graphics for campaigns and social media platforms, enhancing brand visibility and engagement.igital marketing graphics for campaign and social
                    media
                  </li>
                  <li>
                    Successfully managed a team of graphic designers and Android developers to strengthen digital presence and achieve collective goals.
                  </li>
                </ul>
              </div>
              <div className="resume-item">
                <h4>IT/ Digital Marketing Executive</h4>
                <h5>2016 - 2017</h5>
                <p>
                  <em>Shaan Cars PVT LTD, Nashik, India</em>
                </p>
                <ul>
                  <li>Creating visually captivating graphics and artwork to enhance brand presence and engage audiences effectively.</li>
                  <li>Driving lead generation through strategic and impactful digital marketing campaigns.</li>
                  <li>
                    Providing efficient troubleshooting solutions for networking and hardware-related technical issues across multiple company branches.
                  </li>
                </ul>
              </div>
              <div className="resume-item">
                <h4>Founder and web developer</h4>
                <h5>2014-2015</h5>
                <p>
                  <em>Maitrimangal</em>
                </p>
                <ul>
                  <li>
                    Created and developed a highly secure matrimony platform, ensuring privacy and reliability for users.
                  </li>
                  <li>
                    Designed compelling advertising materials for effective digital marketing campaigns.
                  </li>
                  <li>Generated leads through targeted and results-driven digital marketing activities.</li>
                </ul>
              </div>
              <div className="resume-item">
                <h4>Sr. Web developer</h4>
                <h5>2014</h5>
                <p>
                  <em>Techindiana, India</em>
                </p>
                <ul>
                  <li>Successfully developed and designed websites for a diverse range of clients, delivering impactful online experiences that drive user engagement and business growth.</li>
                  <li>Created visually stunning and user-friendly websites that align with client objectives, optimizing them for search engines to improve online visibility and organic traffic.</li>
                </ul>
              </div>
              <div className="resume-item">
                <h4>Web Developer and Consultant</h4>
                <h5>2012 - 2014</h5>
                <p>
                  <em>HP Transcoders, India</em>
                </p>
                <ul>
                  <li>
                    Executed a wide array of marketing programs, encompassing logo designs, brochures, infographics, presentations, and advertisements, to drive brand recognition and engagement.
                  </li>
                  <li>Generated leads through strategically implemented digital marketing campaigns, leveraging targeted strategies and channels for maximum effectiveness.</li>
                  <li>Designed and developed client websites, ensuring a seamless user experience, search engine optimization, and enhanced online presence.</li>
                </ul>
              </div>
              <div className="resume-item">
                <h4>Intern Software Developer</h4>
                <h5>2011 - 2012</h5>
                <p>
                  <em>Virtuetech solutions, Nashik, India</em>
                </p>
                <ul>
                  <li>Created visually appealing graphics and logos, capturing the essence of brands and enhancing their visual identity.</li>
                  <li>
                    Developed comprehensive web applications, handling both front-end and back-end development to ensure seamless functionality and user experience.
                  </li>
                  <li>
                    Implemented GPS devices and coding techniques to track vehicle positions and showcase tracked activities on a customized front-end interface.
                  </li>
                  <li>Generated tailored reports to provide insightful analysis and data-driven insights for clients and stakeholders.</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
